import React, { useRef } from 'react';
import { Plus } from 'lucide-react';
import FileActions from '../../Components/Common/Files/FileActions';
import { useTranslation } from '../../context/Internationalization';
import { Avatar, AvatarFallback, AvatarImage } from '../../shadcn/components/ui/avatar';
import { Button } from '../../shadcn/components/ui/button';
import { FieldDescription } from '../../shadcn/components/ui/field';

export default function RegistrationPhotoField({ preview, selected, error, busy, onChange }) {
  const { t } = useTranslation();
  const input = useRef(null);
  const choosePhoto = () => input.current?.click();
  return <div className="flex flex-col gap-1.5">
    <div className="flex flex-wrap items-center gap-4">
      <Button type="button" variant="ghost" onClick={choosePhoto} disabled={busy}
        aria-label={t('registration_upload_photo_action')} aria-describedby="registration-photo-hint"
        className="size-auto rounded-full p-0 hover:bg-transparent">
        <Avatar className="size-12">
          {preview && <AvatarImage src={preview} alt={t('registration_photo_preview')} />}
          <AvatarFallback><Plus aria-hidden="true" /></AvatarFallback>
        </Avatar>
      </Button>
      <input ref={input} type="file" hidden disabled={busy} accept="image/png,image/jpeg,image/webp"
        aria-label={t('registration_upload_photo')}
        onChange={(event) => {
          if (event.target.files?.[0]) onChange(event.target.files[0]);
          event.target.value = '';
        }} />
      <Button variant="outline" size="sm" type="button" disabled={busy} onClick={choosePhoto}
        aria-invalid={Boolean(error)} aria-describedby="registration-photo-hint">{t('registration_upload_photo')}</Button>
      {preview && <FileActions file={{ url: preview, name: t('registration_photo_preview'), type: "image" }} />}
      {selected && <Button variant="ghost" size="sm" type="button" disabled={busy} onClick={() => onChange(null)}>
        {t('registration_undo_photo')}
      </Button>}
    </div>
    <FieldDescription id="registration-photo-hint" role={error ? 'alert' : undefined}
      className={error ? 'text-destructive' : undefined}>{t(error || 'registration_photo_hint')}</FieldDescription>
  </div>;
}
